import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

import { focusRingInline } from "theme/tokens/accessibility";

const parts = ["root", "item", "trailing"] as const;

const { defineMultiStyleConfig, definePartsStyle } =
  createMultiStyleConfigHelpers(parts);

const baseStyle = definePartsStyle({
  root: {
    minWidth: "200px",
  },

  item: {
    position: "relative",

    display: "flex",
    alignItems: "center",

    px: "3",
    py: "2",
    height: "10",

    color: "fg.muted",
    textStyle: "future.body.sm",

    borderLeft: "2px solid transparent",
    borderRadius: "sm",

    cursor: "pointer",
    transition: "100ms color ease-out, 100ms background ease-out",

    _after: {
      content: "''",

      position: "absolute",
      bottom: "0",
      left: "0",

      w: "full",

      borderBottom: "1px solid",
      borderColor: "border.container",
    },

    _focusVisible: {
      ...focusRingInline,
      zIndex: 1,
    },

    _hover: {
      color: "fg.emphasized",
      _selected: {
        color: "fg.default",
      },
    },

    _selected: {
      bg: "highlight.subtle",
      borderLeftColor: "highlight.solid",

      color: "fg.default",
    },
  },

  trailing: {
    ml: "2",
    justifySelf: "flex-end",
  },
});

export const Sidebar = defineMultiStyleConfig({
  baseStyle,
});
